import DateFunc from '@/lib/lyg/date_func';
import { useState } from 'react';
import DetailRow from "./det_row";
import strFunc from '@/lib/lyg/string';

function RowArea(props: any) {
  let myProps = {
    xColumnArr: {},
    use_info: null,
    textbook_arr: [],
    update_use_main_state_by_ajax: (inData: any) => { },
    update_textbook_use_by_ajax: (inData: any) => { },
    open_word_group_result_popup: (inData: any) => { },
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let use_info = myProps.use_info;
  let textbook_arr = myProps.textbook_arr;
  let text_book_info: any = null;
  for (let i = 0; i < textbook_arr.length; i++) {
    if (textbook_arr[i].a_seq == use_info.a_book_seq) {
      text_book_info = textbook_arr[i];
      break;
    }
  }

  const [is_open_detail, set_is_open_detail] = useState(false);

  use_info["textbook_title"] = "";
  if (text_book_info != null) {
    use_info["textbook_title"] = text_book_info.a_title;
  }

  const on_change_use_input = (inData: any) => {
    let opt_obj = {
      key: "",
      value: "",
      use_info: {},
      ...inData
    };
    let key = opt_obj.key;
    let value = opt_obj.value;
    let new_use_info = { ...opt_obj.use_info };

    if (key == "a_one_day_amount") {
      value = strFunc.uncomma(value);
    }
    new_use_info[key] = value;

    myProps.update_textbook_use_by_ajax({
      up_use_arr: [new_use_info]
    });
  };

  const get_td_tags = () => {
    let td_tags = xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
      let val_str: any = "";
      if (col.key == "row_view_row_num") {
        val_str = idx + 1;
      }

      if (use_info[col.key] !== undefined) {
        val_str = use_info[col.key];
      }

      if (col.key == "row_view_period") {
        if (use_info.a_period_start_date && use_info.a_period_end_date) {
          val_str = use_info.a_period_start_date + " ~ " + use_info.a_period_end_date;
        }
      }

      if (col.key == "row_view_remain_day") {
        val_str = DateFunc.get_diff_days_of_date(new Date(), new Date(use_info.a_period_end_date));
        val_str = Math.ceil(val_str);

        if (val_str < 0) {
          val_str = "";
        }
      }

      if (col.key == "row_view_study") {
        if (text_book_info != null) {
          let row_use_cnt = 0;
          if (use_info && use_info.use_det_arr) {
            row_use_cnt = use_info.use_det_arr.length;
          }
          val_str = row_use_cnt + "/" + text_book_info.study_arr.length;
        }
      }

      if (col.key == "a_one_day_amount") {
        val_str = (
          <input type='number' className='row-input' value={use_info.a_one_day_amount}
            onChange={(e) => {
              on_change_use_input({
                key: "a_one_day_amount",
                value: e.target.value,
                use_info: use_info
              });
            }}
            style={{ width: 50 }} />
        );
      }

      if (col.key == "row_view_detail") {
        val_str = (
          <button className='btn btn-dark' onClick={() => { set_is_open_detail(!is_open_detail) }}>상세</button>
        );
      }

      if (col.key == "row_view_manage") {
        if (use_info["a_is_main"] == "") {
          val_str = (
            <label>
              <input type='checkbox' checked={false} onChange={() => { }} />
              <button className='btn btn-dark ml-1'
                onClick={() => {
                  myProps.update_use_main_state_by_ajax({
                    textbook_seq: use_info.a_book_seq,
                    stu_seq: use_info.a_stu_seq,
                    state: "1"
                  });
                }}>메인교재</button>
            </label>
          );
        } else {
          val_str = (
            <label>
              <input type='checkbox' checked={true} onChange={() => { }} />
              <button className='btn btn-blue ml-1'
                onClick={() => {
                  myProps.update_use_main_state_by_ajax({
                    textbook_seq: use_info.a_book_seq,
                    stu_seq: use_info.a_stu_seq,
                    state: ""
                  });
                }}
              >메인교재</button>
            </label>
          );
        }
      }

      return (
        <td key={idx}>
          <div style={{ minWidth: col.width + "px", textAlign: "center" }}>
            {val_str}
          </div>
        </td>
      );
    });
    return td_tags;
  };

  return (
    <>
      <tr>
        {get_td_tags()}
      </tr>
      {is_open_detail == true &&
        <tr>
          <td colSpan={99}>
            <DetailRow
              use_info={use_info}
              text_book_info={text_book_info}
              open_word_group_result_popup={myProps.open_word_group_result_popup}
            ></DetailRow>
          </td>
        </tr>
      }
    </>
  );
};
export default RowArea;